import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  worker: any;
  id?: number;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }


  ngOnInit(): void {
    this.id = +this.route.snapshot.params['id'];
    this.getWorker();
  }
  

  getWorker(){

    this.okService.get("workers/"+this.id,{expand: "messages"})
    .subscribe((data) => {

      this.worker = data.body;

    });
  }

}
